/** IANA-таймзона для отображения дат в UI (приходит из /api/me → iana_timezone). */
let appTz = "Europe/Moscow";

export function setAppDisplayTimezone(iana) {
  if (typeof iana === "string" && iana.trim()) {
    appTz = iana.trim();
  }
}

export function getAppDisplayTimezone() {
  return appTz;
}
